import SwipeDrawer from "common/Gestures/SwipeDrawer.tsx";
import React, { PropsWithChildren, useContext, useMemo, useRef } from "react";
import FiltersColumn from "common/Filters/FiltersColumn/FiltersColumn.tsx";
import { SwipeFiltersContext } from "common/Filters/common/SwipeFilters.context.ts";
import { PageWrapperFiltersContext } from "common/Home/PageWrapper/PageWrapperFilters.context.ts";
import useDrawers from "common/Home/General/useDrawers.tsx";

const SwipeFilters = ({ children }: PropsWithChildren) => {
  const { filters } = useContext(PageWrapperFiltersContext);
  const swipeActiveRef = useRef(false);
  const { isDrawer } = useDrawers();

  const filtersColumn = filters ? (
    <FiltersColumn
      filtersActions={filters?.actions}
      filtersSelectors={filters?.selectors}
      filterTypeToTitle={filters?.filterTypeToTitle}
      hideFilterTypes={filters?.hideFilterTypes}
      isLoading={filters.loading}
    />
  ) : undefined;

  const contextValue = useMemo(
    () => ({
      swipeActiveRef,
    }),
    []
  );

  return (
    <SwipeFiltersContext.Provider value={contextValue}>
      <SwipeDrawer content={filtersColumn} disabled={isDrawer}>
        {children}
      </SwipeDrawer>
    </SwipeFiltersContext.Provider>
  );
};

export default SwipeFilters;
